import Vue from 'vue';
import Element from 'element-ui';
// @ts-ignore
import locale from 'element-ui/lib/locale/lang/zh-TW';
import Main from '@/main/pages/Main.vue';
import { ComponentsInstaller } from '@/main/componentsInstaller';
import { initStorage } from '@/main/utils/storageHelper';
import { router } from '@/main/router/routeManager';
import { store } from '@/main/store';
import { mixins } from '@/main/mixins';

import { setStore } from '#services/httpRequest';
import '@/scss/custom.scss';

// eslint-disable-next-line no-underscore-dangle
const __svg__ = {
	path: './assets/tiptap/icons/*.svg',
	name: 'assets/tiptap/[hash].sprite.svg',
};
// require basic or custom sprite loader
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

initStorage();

Vue.config.productionTip = false;
Vue.use(ComponentsInstaller);
Vue.use(Element, { locale, size: 'mini' });
Vue.mixin(mixins);

setStore(store);

new Vue({
	name: 'Root',
	router,
	store,
	render: (h) => h(Main),
}).$mount('#app');
